import React from 'react';
import { Text, TextButton } from 'wix-ui-tpa';
import { Trans } from '@wix/yoshi-flow-editor';
import { navigateToParentFolder } from '../../../../../../Services/Search.service';
import { st, classes } from '../../../../../../Shared/SharedText.st.css';
import { classes as itemNameClasses } from './ItemName.st.css';
import { useAppContext } from '../../../../../../Shared/AppContext';

const SearchSubtitle = (props: any) => {
  const { item, isMobile } = props;
  const { compId } = useAppContext();

  const parentFolderObj =
    item?.path?.length > 1 ? item.path[item.path.length - 1] : {};

  return (
    <>
      <Text
        className={
          st(classes.textAndDividersColor, { isMobile }) +
          ' ' +
          itemNameClasses.searchSubtitle
        }
      >
        <Trans
          i18nKey={
            isMobile
              ? 'app.widget.search.in.folder.mobile'
              : 'app.widget.search.in.folder'
          }
          values={{ folder_name: parentFolderObj?.name }}
        >
          <TextButton
            contentClassName={classes.contentEllipsis}
            className={
              st(classes.textButtonAndDividersColor, { isMobile }) +
              ' ' +
              itemNameClasses.textButtonWrapper
            }
            title={parentFolderObj?.name}
            onClick={(e) => {
              if (parentFolderObj?.libraryItemId) {
                e.stopPropagation();
                navigateToParentFolder(item,compId);
              }
            }}
          ></TextButton>
        </Trans>
      </Text>
    </>
  );
};

export default SearchSubtitle;
